/**
 * Direct Cart Update Patch
 * This script directly patches the cart functions in your theme
 */

// Wait for document and cart-notification.js to be fully loaded
document.addEventListener('DOMContentLoaded', function () {
  // Make sure jQuery is available (which Shopify uses)
  const jQueryCheck = setInterval(function () {
    if (window.jQuery) {
      clearInterval(jQueryCheck);
      initCartPatch();
    }
  }, 50);

  // Also try without jQuery as a fallback
  setTimeout(function () {
    if (!window.cartPatchInitialized) {
      initCartPatch();
    }
  }, 1000);

  function initCartPatch() {
    if (window.cartPatchInitialized) return;
    window.cartPatchInitialized = true;

    console.log('[Cart Patch] Initializing...');

    // Direct approach: patch the fetch and XHR methods to intercept cart updates
    patchFetchAndXHR();

    // Monitor form submissions for add-to-cart forms
    monitorFormSubmissions();

    // Monitor add-to-cart button clicks
    monitorAddToCartButtons();

    // Try to hook into cart-notification.js directly
    patchCartNotification();

    // Set up a regular check just in case
    setupPeriodicCheck();
  }

  function patchFetchAndXHR() {
    // Patch fetch API
    if (window.fetch) {
      const originalFetch = window.fetch;
      window.fetch = function (input, init) {
        const url = typeof input === 'string' ? input : input.url;
        const promise = originalFetch.apply(this, arguments);

        if (url && (url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change'))) {
          console.log('[Cart Patch] Intercepted fetch to cart endpoint:', url);
          promise.then(() => {
            setTimeout(updateCartCountBubbles, 300);
          });
        }

        return promise;
      };
    }

    // Patch XMLHttpRequest
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (url && (url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change'))) {
        console.log('[Cart Patch] Intercepted XHR to cart endpoint:', url);
        this.addEventListener('load', function () {
          setTimeout(updateCartCountBubbles, 300);
        });
      }
      return originalOpen.apply(this, arguments);
    };
  }

  function monitorFormSubmissions() {
    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (form.action && form.action.includes('/cart/add')) {
        console.log('[Cart Patch] Cart form submission detected');
        setTimeout(updateCartCountBubbles, 300);
      }
    });
  }

  function monitorAddToCartButtons() {
    document.addEventListener('click', function (e) {
      // Check if the clicked element or any of its parents is an add-to-cart button
      let target = e.target;
      const maxNestingLevel = 5;
      let currentLevel = 0;

      while (target && currentLevel < maxNestingLevel) {
        if (
          target.getAttribute &&
          (target.getAttribute('name') === 'add' ||
            target.getAttribute('data-add-to-cart') !== null ||
            target.classList.contains('add-to-cart') ||
            target.classList.contains('product-form__submit') ||
            (target.form && target.form.action && target.form.action.includes('/cart/add')))
        ) {
          console.log('[Cart Patch] Add to cart button clicked');
          setTimeout(updateCartCountBubbles, 300);
          break;
        }
        target = target.parentElement;
        currentLevel++;
      }
    });
  }

  function patchCartNotification() {
    // Try to find CartNotification class
    setTimeout(function () {
      if (window.CartNotification) {
        console.log('[Cart Patch] Found CartNotification class, patching...');

        // Check if updateQuantity method exists and patch it
        if (typeof window.CartNotification.prototype.updateQuantity === 'function') {
          const originalUpdateQuantity = window.CartNotification.prototype.updateQuantity;
          window.CartNotification.prototype.updateQuantity = function () {
            const result = originalUpdateQuantity.apply(this, arguments);
            console.log('[Cart Patch] CartNotification.updateQuantity called');
            updateCartCountBubbles();
            return result;
          };
        }

        // Check if renderContents method exists and patch it
        if (typeof window.CartNotification.prototype.renderContents === 'function') {
          const originalRenderContents = window.CartNotification.prototype.renderContents;
          window.CartNotification.prototype.renderContents = function () {
            const result = originalRenderContents.apply(this, arguments);
            console.log('[Cart Patch] CartNotification.renderContents called');
            updateCartCountBubbles();
            return result;
          };
        }
      }
    }, 500);
  }

  function setupPeriodicCheck() {
    let lastKnownCount = null;
    // Check every 3 seconds as a last resort
    setInterval(function () {
      fetchCart().then(function (cart) {
        if (lastKnownCount !== cart.item_count) {
          console.log('[Cart Patch] Cart count changed from periodic check:', lastKnownCount, '->', cart.item_count);
          updateCartCountBubbles(cart.item_count);
          lastKnownCount = cart.item_count;
        }
      });
    }, 3000);
  }

  // Main function to update all cart bubbles
  function updateCartCountBubbles(itemCount) {
    // If itemCount wasn't provided, fetch it
    if (itemCount === undefined) {
      return fetchCart().then(function (cart) {
        updateCartCountBubbles(cart.item_count);
      });
    }

    console.log('[Cart Patch] Updating cart bubbles with count:', itemCount);

    // Find all cart count bubbles using specific selectors for this theme
    const cartBubbles = document.querySelectorAll('.cart-count-bubble');

    cartBubbles.forEach(function (bubble) {
      if (itemCount > 0) {
        // Update existing count or create new elements if needed
        let countSpan = bubble.querySelector('span[aria-hidden="true"]');
        if (!countSpan) {
          countSpan = document.createElement('span');
          countSpan.setAttribute('aria-hidden', 'true');
          bubble.appendChild(countSpan);
        }
        countSpan.textContent = itemCount;

        let visuallyHiddenSpan = bubble.querySelector('.visually-hidden');
        if (!visuallyHiddenSpan) {
          visuallyHiddenSpan = document.createElement('span');
          visuallyHiddenSpan.className = 'visually-hidden';
          bubble.appendChild(visuallyHiddenSpan);
        }
        visuallyHiddenSpan.textContent = `Cart count: ${itemCount}`;

        // Make sure the bubble is visible
        bubble.style.display = 'inline-flex';
        bubble.style.opacity = '1';
      } else {
        // Hide bubble for empty cart
        bubble.style.display = 'none';
      }
    });

    // If there are no bubbles, they may not have been rendered yet (for empty cart)
    // Create them for cart icons that don't have them
    if (cartBubbles.length === 0 && itemCount > 0) {
      createMissingBubbles(itemCount);
    }
  }

  function createMissingBubbles(itemCount) {
    // Known cart icon selectors for this theme
    const cartIconSelectors = ['.top-bar-cart-icon', '#cart-icon-bubble', '.header__icon--cart'];

    cartIconSelectors.forEach(function (selector) {
      const cartIcon = document.querySelector(selector);
      if (cartIcon && !cartIcon.querySelector('.cart-count-bubble')) {
        console.log('[Cart Patch] Creating missing bubble for:', selector);

        const bubble = document.createElement('span');
        bubble.className = 'cart-count-bubble';

        const countSpan = document.createElement('span');
        countSpan.setAttribute('aria-hidden', 'true');
        countSpan.textContent = itemCount;

        const visuallyHidden = document.createElement('span');
        visuallyHidden.className = 'visually-hidden';
        visuallyHidden.textContent = `Cart count: ${itemCount}`;

        bubble.appendChild(countSpan);
        bubble.appendChild(visuallyHidden);

        // Determine the best place to insert the bubble
        const svgWrapper = cartIcon.querySelector('.svg-wrapper');
        if (svgWrapper) {
          svgWrapper.insertAdjacentElement('afterend', bubble);
        } else {
          cartIcon.appendChild(bubble);
        }
      }
    });
  }

  // Helper function to fetch cart data
  function fetchCart() {
    return fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .catch(function (error) {
        console.error('[Cart Patch] Error fetching cart:', error);
        return { item_count: 0 };
      });
  }

  // Initialize immediately and check the current cart count
  updateCartCountBubbles();
});
